import React from 'react';
import classNames from 'classnames';

interface Props {
  className?: string;
}

const SuperScriptedCurrency: React.FC<Props> = ({ children, className }) => (
  <span className={classNames('relative text-2xs -top-1 left-0.5', className)}>
    {children}
  </span>
);

export default SuperScriptedCurrency;
